import { BrowserRouter } from "react-router-dom";
import { RoutersMain } from "./Routers";
import { GlobalStyle } from "./Styles/global";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Styles/toastStyles.css";

function App() {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <ToastContainer
        className="custom-toast-container"
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <RoutersMain />
    </BrowserRouter>
  );
}

export default App;
